import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { IEmissionAreaType } from '../../vehicle/models/enums/emission-area-type.enum';
import { Address } from '../models/address.model';

@Injectable({
    providedIn: 'root'
})
export class AddressService extends BaseApiService {
    constructor() {
        super();
    }

    getAddress(addressNumberId: number): Observable<Address> {
        return this.get('Address/address/' + addressNumberId);
    }

    getCustomerAddresses(customerNumberId: number) {
        return this.getMaxResult('Address/address/Customer/' + customerNumberId);
    }

    validateZipCode(zipCode: string) {
        return this.get('Address/validation/zip/' + zipCode);
    }

    setUndeliverable(addressNumberId: number, undeliverable: boolean) {
        return this.get('Address/address/undeliverable/' + addressNumberId + '/' + undeliverable);
    }

    saveAddress(address) {
        return this.post('Address/address/', address, this.replacer).pipe(
            catchError((error) => this.handleError(error)));
    }

    updateEmissionAreaType(addressNumberId: number, emissionAreaType: IEmissionAreaType) {
        return this.post('Address/address/' + addressNumberId + '/EmissionAreaType/' + emissionAreaType, {});
    }

    validateAddress(address) {
        return this.post('address/validation/', address, this.replacer).pipe(
            catchError((error) => this.handleError(error)));
    }

    hasCurbsideDelivery(zip) {
        return this.get('Address/address/curbSideDelivery/' + zip);
    }

    getZipCodeEmissions() {
        return this.get('Customer/ZipCodeEmission');
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error) {
            return observableThrowError(error.error);
        } else {
            return observableThrowError('Server error');
        }
    }

    private replacer(key, value) {
        if (value === '') {
            return undefined;
        }

        return value;
    }
}
